const CommonHeadings = {
  // demo students module
  demoAddHeading: "Add Demo Student",
  demoEditHeading: "Edit Demo Students",
  demoListHeading: "Demo Students",
  demoListLayoutHeading: "Demo Students List",

  // batch module
  batchAddHeading: "Add Batch Information",
  batchEditHeading: "Edit Batch Information",
  batchListHeading: "Batches",
  batchLayoutHeading: "Batches list",
  batchView: "Student's List",

  // teacher module
  teacherAddHeading: "Add Teacher",
  teacherEditHeading: "Edit Teacher",
  teacherListHeading: "Teachers List",
  teacherView: "Teacher List",

  // expense module
  expenseAddHeading: "Add Salary Expense Information",
  expenseEditHeading: "Edit Salary Expense Information",
  expenseListHeading: "Salary Expense List",
  expenseListLayoutHeading: "Salary Expense List",

  // expense basic module
  basicExpenseAddHeading: "Add Basic Expense Information",
  basicExpenseEditHeading: "Edit Basic Expense Information",
  basicExpenseListHeading: "Basic Expense Information List",
  basicExpenseListLayoutHeading: "Basic Expense Information List",

  // regular students module
  studentAddHeading: "Add Regular Student",
  studentEditHeading: "Edit Regular Student",
  studentListHeading: "Regular Students List",
  studentView: "Student Info",

  transactionHistory: "Transaction History",

  studentLayoutHeading: "Student List",


  // pte students module
  pteStudentAddHeading: "Add PTE Student",
  pteStudentEditHeading: "Edit PTE Student",
  pteStudentListHeading: "PTE Students List",

  // user module
  userAddHeading: "Add User",
  userEditHeading: "Edit User",
  userListHeading: "Users List",

  // student performance module
  studentMarksAddHeading: "Add Student's Performance data",
  studentMarksEditHeading: "Edit Student's Performance data",
  studentMarksLayoutHeading: "Student's Performance",

  // mock test module
  mockTestAddHeading: "Add Mock Test Detail",
  mockTestEditHeading: "Edit Mock Test Detail",
  mockTestLayoutHeading: "Student Mock Test List",

  // visa module
  visaAddHeading: "Add Visa Regarding Info",
  visaEditHeading: "Edit Visa Regarding Info",
  visaLayoutHeading: "Visa Detail",

    // notes module
  notesAddHeading: "Add Notes",
  notesEditHeading: "Edit Notes",
  notesLayoutHeading: "Notes Detail",

  // fee module
  feeheading: "Pay Fee",
  feeLayoutHeading: "Pay Fee",

  profile: "Profile"
};

export default CommonHeadings;
